import React, { useEffect, useState } from 'react';
import { PRODUCTS_PER_PAGE } from '../../constants';
import { useDebounce } from '../../../../utils';
import { useFromToContext, useQueryContext } from '../../../shared';
import { useOrderingContext } from '../../hooks';
import { useGetPaginatedProductStatisticsQuery } from '../../../../generated/graphql';
import ProductStatisticsTableView from './ProductStatisticsTableView';

const ProductStatisticsTable = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(PRODUCTS_PER_PAGE);
    const { query } = useQueryContext();
    const { dateFromTo } = useFromToContext();
    const { revenue, quantity, markup, foodCost } = useOrderingContext();

    const handlePageChange = (_e: unknown, pageNumber: number) => {
        setPage(pageNumber);
    };

    const debouncedQuery = useDebounce(query);

    useEffect(() => {
        setPage(0);
    }, [debouncedQuery, dateFromTo]);

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginationProps = {
        onChangePage: handlePageChange,
        onChangeRowsPerPage: handleChangeRowsPerPage,
        currentPage: page,
        rowsPerPage,
    };

    const offset = page * rowsPerPage;

    const { loading, data } = useGetPaginatedProductStatisticsQuery(
        {
            variables: {
                offset, limit: rowsPerPage,
                productName: debouncedQuery,
                dateFromTo,
                revenueSortOrder: revenue || undefined,
                quantitySortOrder: quantity || undefined,
                markupSort: markup || undefined,
                foodCostSort: foodCost || undefined,
            }
        },

    );

    return (
        <ProductStatisticsTableView
            isLoading={loading}
            pagination={paginationProps}
            data={data}
            rowsPerPage={rowsPerPage}
        />
    );
};

export default ProductStatisticsTable;
